var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, OnDestroy, EventEmitter } from '@angular/core';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService } from '@ibe/services/ui';
import { Store } from '@ngrx/store';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../store';
import * as MiniIBEActions from '@ibe/store/actions/mini-ibe.actions';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
var INDRASelectAirportModalComponent = /** @class */ (function (_super) {
    __extends(INDRASelectAirportModalComponent, _super);
    function INDRASelectAirportModalComponent(modalService, store, ibeAdminService) {
        var _this = _super.call(this, modalService) || this;
        _this.modalService = modalService;
        _this.store = store;
        _this.ibeAdminService = ibeAdminService;
        _this.isAlive = true;
        _this.isLoading = true;
        _this.title = '';
        _this.query = _this.airport !== null ? _this.airport : '';
        _this.hasFocus = false;
        _this.showAutocomplete = true;
        _this.loading$ = _this.store.select(fromStore.getUserLoading);
        _this.activeInput$ = _this.store.select(fromStore.getMiniIBEActiveInput);
        _this.routeType$ = _this.store.select(fromStore.getMiniIBERouteType);
        _this.completeOptions = [];
        _this.dataOptions = [];
        _this.id = '';
        _this.searchRoutes$ = _this.store.select(fromStore.getMiniIBESearchRoutes);
        _this.currentSearch$ = _this.store.select(fromStore.getMiniIBECurrentSeachRoute);
        _this.selected = new EventEmitter();
        // required for ControlValueAccessor
        _this.propagateChange = function (_) { };
        _this.activeInput$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.title = (value === 'from' ? _this.INDRA_getTranslation('bookingSearch.label.departure') : _this.INDRA_getTranslation('bookingSearch.label.arrival')) + " " + _this.INDRA_getTranslation('bookingSearch.text.airport');
                _this.activeInput = value === 'from' ? 'departure' : 'arrival';
            }
        });
        _this.routeType$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.routeType = value;
                if (value == 'multicity')
                    _this.completeOptions = ['seach-region'];
            }
        });
        _this.currentSearch$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) { return _this.currentSearch = value; });
        _this.searchRoutes$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) { return _this.searchRoutes = value; });
        return _this;
    }
    INDRASelectAirportModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (this.data && this.data[0] && this.data[0].params && this.data[0].params.dataOptions) {
            this.dataOptions = this.data[0].params.dataOptions;
            this.id = this.data[0].params.id;
            this.callback = this.data[0].handleClose;
        }
        this.loading$.pipe(takeWhile(function () { return _this.isAlive; })).subscribe(function (value) {
            _this.isLoading = value;
        });
        this.airport = this.searchRoutes[this.currentSearch][this.activeInput];
    };
    INDRASelectAirportModalComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
    };
    Object.defineProperty(INDRASelectAirportModalComponent.prototype, "INDRA_printAirportName", {
        /**
         * Print airport name on input
         */
        get: function () {
            if (this.airport && this.airport.location) {
                var airport = this.airport;
                // Check if airport name is diferent then city name
                var airportName = airport.location.city.toLowerCase() === airport.name.toLowerCase() ? '' : airport.name + ', ';
                return (airport.location.city + ', ' + airportName + airport.location.country);
            }
            if (this.airport && this.airport['type']) {
                return this.airport['value'].label;
            }
            return '';
        },
        enumerable: true,
        configurable: true
    });
    INDRASelectAirportModalComponent.prototype.INDRA_clearInput = function () {
        this.airport = '';
    };
    /**
     * Print airport iata code on input
     */
    INDRASelectAirportModalComponent.prototype.INDRA_printAirportCode = function () {
        if (this.airport && this.airport.location) {
            var airport = this.airport;
            return airport.code;
        }
        if (this.airport && this.airport['type']) {
            return this.airport['value'].icon;
        }
        return '';
    };
    INDRASelectAirportModalComponent.prototype.INDRA_printTitle = function () {
        return this.title;
    };
    INDRASelectAirportModalComponent.prototype.INDRA_printLabel = function () {
        return !this.airport;
    };
    INDRASelectAirportModalComponent.prototype.INDRA_handleInputBlur = function (e) {
        this.hasFocus = false;
        if (this.airport instanceof Object) {
            this.propagateChange(this.airport);
        }
    };
    INDRASelectAirportModalComponent.prototype.INDRA_handleInputFocus = function (e) {
        this.hasFocus = true;
    };
    INDRASelectAirportModalComponent.prototype.INDRA_handleInputChange = function (e) {
        this.query = e.target.value;
        this.propagateChange(e.target.value);
    };
    INDRASelectAirportModalComponent.prototype.INDRA_handleSelect = function (e) {
        var _this = this;
        if (e !== null) {
            this.hasFocus = false;
            this.showAutocomplete = false;
        }
        if (e && e.type == 'recent-search') {
            var newSearchRoutes = Object.assign([], this.searchRoutes);
            if (this.searchRoutes.length >= this.currentSearch + 1) {
                newSearchRoutes = newSearchRoutes.map(function (cur, idx) {
                    if (idx === _this.currentSearch)
                        cur = e.value;
                    return cur;
                });
            }
            else {
                newSearchRoutes.push(e.value);
            }
            this.store.dispatch(new MiniIBEActions.PutActiveInput(null));
            this.store.dispatch(new MiniIBEActions.PutSearchRoute(newSearchRoutes));
        }
        else {
            this.writeValue(e);
            this.propagateChange(e);
        }
        if (e) {
            if (this.data && this.data[0] && this.data[0].handleClose) {
                this.data[0].handleClose(e);
            }
        }
        this.closeModal();
    };
    INDRASelectAirportModalComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    INDRASelectAirportModalComponent.prototype.registerOnTouched = function () { };
    INDRASelectAirportModalComponent.prototype.writeValue = function (value) {
        this.airport = value;
    };
    INDRASelectAirportModalComponent.prototype.closeModal = function () {
        this.modalService.close();
    };
    INDRASelectAirportModalComponent.prototype.INDRA_getTranslation = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    return INDRASelectAirportModalComponent;
}(AbstractModalContentComponent));
export { INDRASelectAirportModalComponent };
